window.$(document).ready(function () {
  let menuTrigger = window.$('.off-canvas-toggle'),
    nav = window.$('.off-canvas'),
    closeButton = nav.find('.off-canvas__close'),
    siteBody = window.$('#top');

    // open-close menu by clicking on the menu icon
  menuTrigger.on('click', function (e) {
    e.preventDefault();
    menuTrigger.toggleClass('is-clicked');
    siteBody.toggleClass('off-canvas-is-active');
  });
  // close menu by clicking the close button
  closeButton.on('click', function (e) {
    e.preventDefault();
    menuTrigger.trigger('click');
  });
  // close menu clicking outside the menu itself
  siteBody.on('click', function (e) {
    let eTarget = window.$(e.target);
    if (!eTarget.is('.off-canvas, .off-canvas *, .off-canvas-toggle, .off-canvas-toggle span, .off-canvas-toggle i')) {
      menuTrigger.removeClass('is-clicked');
      siteBody.removeClass('off-canvas-is-active');
    }
  });
  // open (or close) submenu items in the off-canvas menu.
  // Close all the other open submenu items.
  window.$('.off-canvas__list .has-children').children('a').on('click', function (e) {
    e.preventDefault();
    window.$(this).toggleClass('sub-menu-is-open')
      .next('.sub-menu')
      .slideToggle(200)
      .end()
      .parent('.has-children')
      .siblings('.has-children')
      .children('a')
      .removeClass('sub-menu-is-open')
      .next('.sub-menu')
      .slideUp(200);
  });
});